import type { ReactNode } from "react";
import TrafficDots from "./TrafficDots";

/** Light browser window chrome (traffic dots + URL pill). */
export default function BrowserWindow({
  url,
  children,
}: {
  url?: string;
  children: ReactNode;
}) {
  return (
    <div className="overflow-hidden rounded-ref-lg border border-line-2 bg-surface shadow-ref-lg">
      <div className="flex items-center gap-2 border-b border-line bg-surface-2 px-[15px] py-[11px]">
        <TrafficDots />
        {url && (
          <span className="mx-auto rounded-[7px] border border-line bg-surface px-3.5 py-1 font-jetbrains text-xs text-muted">
            {url}
          </span>
        )}
      </div>
      {children}
    </div>
  );
}
